import { ForumError, forumEnvelope, forumError, invalidResponse, staleResponse } from './forumErrors';
import { forumId } from '../models/forumMappers';

// One mutation per thread and session. Never replay a POST automatically: even
// a timeout can mean the server committed the requested moderation state.
export function createForumModerationRepository({ http, getIdentity, invalidate = () => {} }) {
  const flights = new Map(), identity = () => JSON.stringify(getIdentity() || {});
  return {
    change(threadId, action, value) {
      const id = forumId(threadId), owner = identity();
      if (!id || !['pin', 'hide'].includes(action) || typeof value !== 'boolean') return Promise.reject(invalidResponse());
      if (!forumId((getIdentity() || {}).uid)) return Promise.reject(staleResponse());
      const key = owner + ':' + id, command = action + ':' + value, pending = flights.get(key);
      if (pending) return pending.command === command ? pending.promise : Promise.reject(new ForumError('moderation_busy', 'Espera a que termine el cambio del hilo.', 409));
      const current = () => { if (identity() !== owner) throw staleResponse(); };
      const request = Promise.resolve().then(() => { current(); return http.post('/forum/api/v2/moderation', { thread_id: id, action, value }); }).then(response => {
        current(); const data = forumEnvelope(response.data).data;
        if (forumId(data.thread_id) !== id || data.action !== action || data.value !== value) throw invalidResponse();
        try { invalidate(['thread:' + id, 'topics', 'activity']); } catch (_) { /* The confirmed state remains authoritative. */ }
        return { threadId: id, action, value: data.value };
      }).catch(error => {
        current(); const failure = forumError(error);
        if ((!failure.status && failure.code !== 'stale_response') || failure.status >= 500) {
          throw new ForumError('moderation_uncertain', 'No se pudo confirmar el cambio. Comprueba el estado del hilo antes de continuar.', failure.status);
        }
        if (failure.status === 403 && failure.code !== 'csrf_invalid') throw new ForumError('moderation_denied', 'No tienes permiso para esta acción. Comprueba los permisos actuales del hilo.', 403);
        throw failure;
      }).finally(() => { if (flights.get(key)?.promise === request) flights.delete(key); });
      flights.set(key, { command, promise: request }); return request;
    }
  };
}
